<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-profile"
            v-if="isAccountLoaded">
            <NavBarLogo :isShowCart="true" :namePage="trackingEventCategory"></NavBarLogo>
            <div class="header-top bg-white">
                <!-- <div class="wave-background" :class="userType"></div> -->
                <div id="header_content" class="bg-a-green-E9F4ED mx-5u rounded-md">
                    <div class="flex">
                        <div>
                            <div id="img-profile">
                                <img class="img-fluid" :src="getPictureLine()" v-if="isLine" />
                                <img class="img-fluid" src="../../../assets/other/pic_profile.png" v-if="!isLine" />
                            </div>
                        </div>
                        <div id="user_info">
                            <div id="user_name">คุณ{{`${profile.strFirstName} ${profile.strLastName}`}}</div>
                            <div id="user_point" class="theme-txt">{{point | number_format}} <span class="point_unit">คะแนน</span></div>
                        </div>
                    </div>
                    <div id="point_expired">
                        มี <span class="ex-point">{{expiringPoint | number_format}} คะแนน</span> จะหมดอายุภายใน {{formatDate(expiringTime)}}
                    </div>
                </div>
                <div id="profile_menu">
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('profile/edit')">
                        <div>{{lbl.profile.menu_edit_profile}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between"
                        @click="goShoppingCartProduct()">
                        <div>{{lbl.profile.menu_edit_shipping_address}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('invite')">
                        <div>{{lbl.profile.menu_invite_friend}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between"
                        @click="clickMyOrder"
                        v-if="false">
                        <div>{{lbl.profile.menu_my_order}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('terms')">
                        <div>{{lbl.profile.menu_terms}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <!-- <div class="profile-menu d-flex justify-content-between" @click="clickMarketing()">
                        <div>{{lbl.profile.menu_marketing}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div> -->
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('aboutus')">
                        <div>{{lbl.profile.menu_about}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('contactus')">
                        <div>{{lbl.profile.menu_contact}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div id="version_bzbslogo" class="profile-menu d-flex justify-content-between">
                        <div id="text_version">V.1</div>
                        <div id="logo_bzbs">
                            <img src="../../../assets/icon/newversion/logo_bzb_gray.svg">
                        </div>
                    </div>
                    <!-- <div class="profile-menu d-flex justify-content-between" @click="goToPage('personal/copy')">
                        <div>{{lbl.profile.menu_raq_copy}}</div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div>
                    <div class="profile-menu d-flex justify-content-between" @click="goToPage('personal/transfer')">
                        <div v-html="lbl.profile.menu_send_copy"></div>
                        <div class="icon-arrow-link"><img src="../../../assets/icon/newversion/chevron-right.svg"></div>
                    </div> -->

                    <!-- ตัดแถบ ออกจากระบบ ออก -->
                    <!-- <div class="profile-menu d-flex">
                        <div class="btn-logout1 theme-txt" @click="clickLogout">ออกจากระบบ</div>
                    </div> -->
                    <div class="btn-cancel-member" @click="clickUnscription">ยกเลิกการเป็นสมาชิก</div>
                </div>
                

                
            </div>

            <modal-master :controller="modalController" :theme="userType"></modal-master>

            <tab-bar
                :lblTab="lbl.tabbar"
                :theme="userType"
                tabActive="profile"></tab-bar>
            <!-- <cookie-consent-bar></cookie-consent-bar> -->
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//helper
import LineFunction from "@/helper/facede/LineFunction.js";
import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TabBar from "@/components/Layout/TabBar/TabBar.vue";
// import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
// import CookieConsentBar from "@/components/Layout/CookieConsentBar/CookieConsentBar.vue";
//core
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import ProfileService from "../service/ProfileService";
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import { AccessKeyModel } from '@/core/Account/model/AccessKeyModel.js';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { ShippingModalController } from "@/components/Modal/Controller/ShippingModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { MarketingModalController } from "@/components/Modal/Controller/MarketingModalController.js";

export default {
    name: "Profile",
    mixins: [
        AccountMixin,
        LocaleMixin,
        ErrorApiMixin
    ],
    components: {
        TabBar,
        ModalMaster,
        // CookieConsentBar,
        // TopBar,
        NavBarLogo
    },
    computed: {
        userType: function () {
            console.log(this.$store.state.userType);
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            isLoading: false,
            expiringPoint: 0,
            expiringTime: 0,
            //error handler
            errorHandler: null,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            shippingModal: new ShippingModalController(),
            loadingModal: new LoadingModalController(),
            marketingModal: new MarketingModalController(),

            trackingService: new TrackingService(this),
            trackingScreenName: 'profile',
            trackingEventCategory: 'profile_page',
            config: Vue.bzbsConfig
        };
    },
    created: function () {
        this.getExpiringPoint();
        // this.initialLogo();
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setShippingModal(this.shippingModal);
        this.modalController.setMarketingModal(this.marketingModal);
        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        //event
        clickEditAddress: function () {
            this.bzbTracking('editAddress')
            this.shippingModal
                .clearModal()
                .setTitle(this.lbl.shipping.profile_headline)
                .setTag('edit-address')
                .setPage('profile')
                .setBack(true)
                .show();

            this.shippingModal.onInternetError((err)=>{
                this.errorResponse(err, this.errorHandler);
            });
        },
        clickMyOrder: function () {
            this.trackingService.event(this.trackingEventCategory, 'click_my_order', null, null)
            var token = this.getToken();
            if (token) {
                var return_url = encodeURIComponent(location.href);
                var url = `${Vue.bzbsConfig.bzbNewShoppingCartUrl}/myorder?token=${token}&locale=${this.localeCode}&theme=ecommerce_brand_a&brand=cpffeed&return_url=${return_url}&api=${Vue.bzbsConfig.api_prefix}&multilang=true`;

                window.location = url;
            }
        },
        clickUnscription: function () {
            this.trackingService.event(this.trackingEventCategory, 'click_cancelmember', null, null)

            console.log(this.lbl.profile.unsubscription_headline);
            this.confirmModal
                .clearText()
                .setTag('profile-unsubscript')
                .setTitle(this.lbl.profile.unsubscription_headline)
                .setMsg(this.lbl.profile.unsubscription_msg)
                .setBtnCancel(this.lbl.profile.unsubscription_cancel)
                .setBtnOk(this.lbl.profile.unsubscription_confirm)
                .show();

            this.confirmModal.onClickCancel(() => {
                this.trackingService.event(this.trackingEventCategory, 'click_cancel', null, null)

                this.confirmModal.hide();
            });

            this.confirmModal.onClickOk(() => {
                this.trackingService.event(this.trackingEventCategory, 'click_confirm', null, null)

                this.unsubscriptMember()
            });
        },
        clickLogout: function () {
            var trackingEventCategory = 'profile_page'
            var eventName = 'click_logout'
            this.trackingService.event(trackingEventCategory, eventName, null, null)

            this.confirmModal
                .clearText()
                .setTag('profile-logout')
                .setTitle(this.lbl.profile.logout_headline)
                .setMsg(this.lbl.profile.logout_message)
                .setBtnCancel(this.lbl.profile.logout_cancel)
                .setBtnOk(this.lbl.profile.logout_confirm)
                .show();

            this.confirmModal.onClickCancel(() => {
                trackingEventCategory = 'profile_page'
                eventName = 'click_logout_cancel'
                this.trackingService.event(trackingEventCategory, eventName, null, null)

                this.confirmModal.hide();
            });

            this.confirmModal.onClickOk(() => {
                trackingEventCategory = 'profile_page'
                eventName = 'click_logout_confirm'
                this.trackingService.event(trackingEventCategory, eventName, null, null)

                var isFromLine = Account.getCacheCustom('BzbsIsFromLine');
                let line = new LineFunction();
                if (isFromLine) {
                    //window.location.replace('/linelogin');
                    line.logout();
                } else {
                    window.location.replace('/register');
                }
            });
        },
        //method
        getExpiringPoint: function () {
            var token = this.getToken();
            BzbsProfile.apiGetExpiringPoint(token)
                .then(res => {
                    this.expiringPoint = res.data.expiring_points.points;
                    this.expiringTime = res.data.expiring_points.time;
                }).catch(err => {
                    this.errorResponse(err, this.errorHandler);
                });
        },
        unsubscriptMember: function () {
            var token = this.getToken();
            this.showLoading();
            ProfileService.unsubscriptMember(token)
                .then(() => {
                    this.hideLoading();
                    this.alertModal
                        .clearText()
                        .setTitle(this.lbl.profile.unsubscript_success_headline)
                        .setMsg(this.lbl.profile.unsubscript_success_msg)
                        .setBtnOk(this.lbl.profile.unsubscript_success_ok)
                        .setTag('profile-unsubscript')
                        .show();
                    this.alertModal.onClickOk(()=>{
                        var isFromLine = Account.getCacheCustom('BzbsIsFromLine');
                        let line = new LineFunction();
                        if (isFromLine) {
                            //window.location.replace('/linelogin');
                            line.logout();
                        } else {
                            window.location.replace('/register');
                        }
                        })
                }).catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        //Util
        formatDate: function (time) {
            if (!time) return;
            var expiringPointTime = time;

            var result = Moment.unix(expiringPointTime).utc();
            var year = Moment.unix(expiringPointTime).utc().format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return date;
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        },
        goToPage: function(page) {
            this.bzbTracking(page)
            this.$router.push('/' + page)
        },
        clickMarketing: function() {
            this.marketingModal.show();
        },
        bzbTracking: function(page) {
            var eventName = ''
            switch(page) {
                case 'profile/edit':
                    eventName = 'click_edit_information'
                    break;
                case 'editAddress':
                    eventName = 'click_my_order'
                    break;
                case 'invite':
                    eventName = 'click_fgf'
                    break;
                case 'terms':
                    eventName = 'click_terms_and_condition'
                    break;
                case 'aboutus':
                    eventName = 'click_about_us'
                    break;
                case 'contactus':
                    eventName = 'click_contact_us'
                    break;
            }
            
            this.trackingService.event(this.trackingEventCategory, eventName, null, null)
        },
        goShoppingCartProduct: async function() {
            this.trackingService.event(this.trackingEventCategory, 'click_my_order', null, null)
            let token = this.getToken();
            let accessKey = await this.getShoppingCartAccessKey(token)

            if (accessKey == null) {
                return
            }

            let appName = this.config.appname;
            let url = this.config.bzbNewShoppingCartUrl + `/landing/${appName}/myorder?access_key=${accessKey}&appname_config=${appName}`
            window.location.href = url
        },
        getShoppingCartAccessKey: function(token) {
            return new Promise((resolve) => {
                let currentUrl = window.location.href
                let payload = {
                    returnUrl: currentUrl,
                    successUrl: currentUrl,
                    errorUrl: currentUrl,
                    appId: this.config.client_id,
                    appName: this.config.appname,
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(token, jsonPayload)
                    .then(res => {
                        let accessKey = new AccessKeyModel()
                        accessKey.setDataFromApi(res.data.data)
                        resolve(accessKey.accessKey);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "Profile.scss";
</style>
